import React from "react";
import Fancybox from "../Fancybox/Fancybox";
import GoogleMap from "../GoogleMap/GoogleMap";

const ContactForm = () => {
  const modulo = (e) => {
    console.log(e);
  };

  return (
    <div className="contact-form">
      <form>
        <div className="form-row">
          <div className="form-item">
            <input type="text" placeholder="Nome" />
          </div>
          <div className="form-item">
            <input type="text" placeholder="Cognome" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-item">
            <input type="email" placeholder="Email" />
          </div>
          <div className="form-item">
            <input type="number" placeholder="Telefono" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-item-100">
            <textarea
              name="richiesta"
              placeholder="Inserisci qui il tuo messaggio"
            />
          </div>
        </div>
        <div className="form-legal">
          <p>
            La riforma europea della disciplina sulla Protezione dei Dati - GDPR
            2016/679 sancisce il principio del consenso esplicito nel momento in
            cui gli interessati forniscono i propri dati (compreso l'indirizzo
            email) per finalità promozionali e di marketing, incluso l'invio di
            newsletter. A partire dal 25 Maggio 2018 quindi per poter gestire le
            sua richiesta dobbiamo ricevere il consenso esplicito al trattamento
            dei suoi dati. Le chiediamo quindi di{" "}
            <Fancybox>
              <a
                href="http://dev18.makemedia.it/privacy-policy/"
                data-fancybox
                data-type="iframe"
                data-preload="false"
                data-width="640"
                data-height="480"
              >
                leggere l'informativa completa cliccando qui
              </a>
            </Fancybox>
            ed esprimere il suo consenso cliccando sul tasto Acconsento. Potrà
            revocare il consenso al trattamento per questa finalità in ogni
            momento. Il suo indirizzo mail non sarà comunicato, ceduto, o
            venduto singolarmente o come parte di un database di contatti a
            terze parti, in nessuna occasione.
          </p>
          <label>
            <input type="checkbox" /> Accetto
          </label>
        </div>
        <button onClick={modulo()}>Invia richiesta</button>
      </form>
    </div>
  );
};

export default ContactForm;
